import React from 'react';
import { withTranslation, WithTranslation, Trans } from 'react-i18next';
import { URLS } from '@wix/da-url';
import { IconSize } from '@wix/da-shared-react/pkg/Icons/IconWrap';
import FavouriteOutfilled from '@wix/da-shared-react/pkg/Icons/FavouriteOutfilled/FavouriteOutfilled';

import EmptyState from '../../../EmptyState';
import { GallectionType } from '../../../../../types/gallection';
import s from './GallectionsEmptyState.scss';

export interface Props {
  gallectionType: GallectionType;
  ownerUsername: string;
  isOwner: boolean;
}

export class GallectionsEmptyState extends React.Component<
  Props & WithTranslation
> {
  render() {
    const { isOwner, t, gallectionType } = this.props;

    return (
      <EmptyState
        view="large"
        className={s['root']}
        title={
          isOwner
            ? t(`pages.gallections.${gallectionType}.emptyState.title.owner`)
            : t(`pages.gallections.${gallectionType}.emptyState.title.visitor`)
        }
        subtitle={this.getSubtitle()}
        buttonLabel={
          isOwner
            ? t<string>(
                `pages.gallections.${gallectionType}.emptyState.buttonCTA.owner`
              )
            : undefined
        }
        onButtonClick={isOwner ? this.onButtonClick : undefined}
        withButton={isOwner}
      />
    );
  }

  onButtonClick = () => {
    if (this.props.gallectionType === GallectionType.GALLERY) {
      this.navigateToSubmit();
    } else {
      this.navigateToBrowse();
    }
  };

  navigateToSubmit() {
    window.location.replace(URLS.SUBMIT);
  }

  navigateToBrowse() {
    window.location.replace(URLS.ROOT);
  }

  getSubtitle() {
    const { isOwner, gallectionType, t, ownerUsername } = this.props;
    if (isOwner) {
      return gallectionType === GallectionType.COLLECTION ? (
        <>
          {/* prettier-ignore */}
          <Trans i18nKey="pages.gallections.collection.emptyState.subtitle.owner">
            Simply star{' '}
            <FavouriteOutfilled
              size={IconSize.SMALL}
              className={s['star']}
            />{' '}
            your favourite deviations as you browse, to show other deviants what you love.
          </Trans>
        </>
      ) : (
        t(`pages.gallections.${gallectionType}.emptyState.subtitle.owner`)
      );
    }

    return t(
      `pages.gallections.${gallectionType}.emptyState.subtitle.visitor`,
      { username: ownerUsername }
    );
  }
}

export default withTranslation()(GallectionsEmptyState);
